import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ScriptListLayer from "../../components/TradingSettings/ScriptListLayer";

const ScriptListPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Script Management" />
      <ScriptListLayer />
    </MasterLayout>
  );
};

export default ScriptListPage;
